export const list = [
  {
    name: 'NPU40T-BMC_1.02.tar.gz',
    desc: '主板BMC升级包',
    size: '26MB',
    publish: '2023.5.17',
    href: 'https://pan.yitu-inc.com/file/xhhyjm8amp4wy62bjh1o6ei37m2kni0p#',
    belong: ['2140系列服务器', '2240系列服务器', '2280系列服务器'],
    version: '1.02',
  },
  {
    name: 'NPU40T-BMC_MIB_1.02.tar.gz',
    desc: 'SNMP接口配套MIB文件',
    size: '2.08KB',
    publish: '2023.5.17',
    href: 'https://pan.yitu-inc.com/file/su7vhq91yttoy115o7ojydlvtnlsy79k#',
    belong: ['2140系列服务器', '2240系列服务器', '2280系列服务器'],
    version: '1.02',
  },
  {
    name: 'NPU40T-2140-2140A_BIOS_1.02.tar.gz',
    desc: '主板BIOS升级包',
    size: '1.87MB',
    publish: '2023.5.17',
    href: 'https://pan.yitu-inc.com/file/u3kfliafjzhlirlpz4hyl1tejucie3sv#',
    belong: ['2140系列服务器'],
    version: '1.02',
  },
  {
    name: 'NPU40T-2240-2240A_BIOS_1.02.tar.gz',
    desc: '主板BIOS升级包',
    size: '1.87MB',
    publish: '2023.5.17',
    href: 'https://pan.yitu-inc.com/file/mfmp2dj9htehsls6cisxk9102hvwivs8#',
    belong: ['2240系列服务器'],
    version: '1.02',
  },
  {
    name: 'NPU40T-2280-2280A_BIOS_1.02.tar.gz',
    desc: '主板BIOS升级包',
    size: '1.88MB',
    publish: '2023.5.17',
    href: 'https://pan.yitu-inc.com/file/wegcr0bktb0ogv8p65zoductj10mddfo#',
    belong: ['2280系列服务器'],
    version: '1.02',
  },
  {
    name: 'NPU40T-Tools_1.02.tar.gz',
    desc: '工具包',
    size: '1.68KB',
    publish: '2023.5.17',
    href: 'https://pan.yitu-inc.com/file/x2ke0ya6e4cy3s82kisni4xubmybu36u#',
    belong: ['2140系列服务器', '2240系列服务器', '2280系列服务器'],
    version: '1.02',
  },
  {
    name: 'NPU40T-2240I_BMC_1.04.tar',
    desc: '主板BMC升级包',
    size: '27.83MB',
    publish: '2023.8.3',
    href: 'https://pan.yitu-inc.com/file/h4rq36k8c0hgpp8giz209hzpz2vjs99t#',
    belong: ['2240系列服务器'],
    version: '1.04',
  },
  {
    name: 'NPU40T_BMC-MIB_1.04.tar.gz',
    desc: 'SNMP接口配套MIB文件',
    size: '32.11KB',
    publish: '2023.8.3',
    href: 'https://pan.yitu-inc.com/file/f0q2vq4qoq66om41ddbh3o6b9qsa49kq#',
    belong: ['2240系列服务器'],
    version: '1.04',
  },
  {
    name: 'NPU40T-2240I_BIOS_1.04.tar.gz',
    desc: '主板BIOS升级包',
    size: '2.07MB',
    publish: '2023.8.3',
    href: 'https://pan.yitu-inc.com/file/m0rs4rf2gqpx6u5ttklk6yxcurbxfo5b#',
    belong: ['2240系列服务器'],
    version: '1.04',
  },
  {
    name: 'NPU40T_Tools_1.04.tar.gz',
    desc: '工具包',
    size: '4.3KB',
    publish: '2023.8.3',
    href: 'https://pan.yitu-inc.com/file/20clzpwchq7xz8immnvftf2fhw78a2kl#',
    belong: ['2240系列服务器'],
    version: '1.04',
  },
];

export const optionsList = [
  {
    id: 1.04,
    value: '1.04',
    label: '1.04',
    belong: ['2240系列服务器'],
  },
  {
    id: 1.02,
    value: '1.02',
    label: '1.02',
    belong: ['2140系列服务器', '2240系列服务器', '2280系列服务器'],
  },
];
